export default {
        srcSet: __webpack_public_path__ + "3f7a7d1bfb1c2c9a-700.webp"+" 700w",
        images: [{path: __webpack_public_path__ + "3f7a7d1bfb1c2c9a-700.webp",width: 700,height: 978}],
        src: __webpack_public_path__ + "3f7a7d1bfb1c2c9a-700.webp",
        toString: function(){return __webpack_public_path__ + "3f7a7d1bfb1c2c9a-700.webp"},
        placeholder: "data:image/webp;base64,UklGRpwAAABXRUJQVlA4IJAAAADwAwCdASoUABwAPp1Gmkqlo6IhqAqosBOJQAO1EBVV7fT+GyMG9wSgAP77gpby4/+gUBWOlF5uFgbR+XfnFtAh8LTdRzU5p7Xs+rqnEo0//vdSvVUWQAuDfCV2JCvdRZhNwe00+PA0z/5jHjw9nGF7LGJeKgoe8kjTK2I/8TNCHlWDd7y2ANx/DNYwTygAAAA=",
        width: 700,
        height: 978
      }